<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Security</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Users
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button class="btn btn-primary pull-left" @click="createItem()">
                  <span>&#43;</span> Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Users
                    <span><i class="ic-settings-horizontal"></i></span>
                  </h2>
                  <p>Create and manage application users.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Username, Email"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>Username</th>
                  <th>Full Name</th>
                  <th>Email</th>
                  <th class="text-center">Selector</th>
                  <th class="text-left">Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>{{ item.username }}</td>
                  <td>{{ item.firstName }} {{ item.lastName }}</td>
                  <td>{{ item.email }}</td>
                  <td
                    class="text-center"
                    :class="{ 'sts-danger': !userItemContainSelector(item) }"
                  >
                    {{ printSelectorIndicator(item.selectors) }}
                  </td>
                  <td class="text-left">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        @change="changeStatus(item)"
                        :disabled="item.isRoot"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="isAllowToUpdate"
                        class="btn btn-default"
                        type="button"
                        @click="updateItem(item.id)"
                      >
                        <span>Edit</span>
                      </button>
                      <button
                        v-if="item.isSyncWithAuth && isAllowToUpdate"
                        class="btn btn-default"
                        type="button"
                        @click="resetPassword(item)"
                      >
                        <span>Reset</span>
                      </button>
                      <button
                        v-if="!item.isSyncWithAuth && isAllowToUpdate"
                        class="btn btn-default --green35"
                        type="button"
                        @click="openAuthModal(item)"
                      >
                        <span>Sync</span>
                      </button>
                      <button
                        v-if="
                          isAllowToDelete &&
                          (!item.isRoot || !isHimSelf(item.username))
                        "
                        class="btn btn-default"
                        type="button"
                        @click="confirmDelete(item)"
                      >
                        <i class="ic-close"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="usermodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>User</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body mt-5">
                  <ul
                    class="nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"
                  >
                    <li :class="[activeTab === 'general' ? 'active' : '']">
                      <a
                        href="#identity-user-general"
                        data-toggle="tab"
                        @click="activeTab = 'general'"
                      >
                        <span class="required">General</span>
                      </a>
                    </li>
                    <li :class="[activeTab === 'role' ? 'active' : '']">
                      <a
                        href="#identity-user-role"
                        data-toggle="tab"
                        @click="activeTab = 'role'"
                      >
                        <span class="required">Roles</span>
                      </a>
                    </li>
                    <li :class="[activeTab === 'policy' ? 'active' : '']">
                      <a
                        href="#identity-user-policy"
                        data-toggle="tab"
                        @click="activeTab = 'policy'"
                      >
                        <span>Policies</span>
                      </a>
                    </li>
                    <li :class="[activeTab === 'selector' ? 'active' : '']">
                      <a
                        href="#identity-user-selector"
                        data-toggle="tab"
                        @click="activeTab = 'selector'"
                      >
                        <span>Selector</span>
                      </a>
                    </li>
                  </ul>
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="tab-content">
                      <div
                        id="identity-user-general"
                        class="tab-pane fade"
                        :class="[activeTab === 'general' ? 'in active' : '']"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">Username</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.username.$error,
                                }"
                                v-model="model.username"
                                :disabled="isUpdate"
                              />
                              <div
                                v-if="isSubmitted && $v.model.username.$error"
                              >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.username.required"
                                  >Username is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.username.maxLength"
                                  >Username must be less than
                                  {{ $v.model.username.$params.maxLength.max }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-if="!isUpdate">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">Password</label>
                              <input
                                type="password"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.password.$error,
                                }"
                                v-model="model.password"
                              />
                              <div
                                v-if="isSubmitted && $v.model.password.$error"
                              >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.password.required"
                                  >Password is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.password.maxLength"
                                  >Password must be less than
                                  {{ $v.model.password.$params.maxLength.max }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">First Name</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.firstName.$error,
                                }"
                                v-model="model.firstName"
                              />
                              <div
                                v-if="isSubmitted && $v.model.firstName.$error"
                              >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.firstName.required"
                                  >First Name is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.firstName.maxLength"
                                  >First Name must be less than
                                  {{ $v.model.firstName.$params.maxLength.max }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Last Name</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.lastName.$error,
                                }"
                                v-model="model.lastName"
                              />
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted && !$v.model.lastName.maxLength
                                "
                                >Last Name must be less than
                                {{ $v.model.lastName.$params.maxLength.max }}
                                characters</small
                              >
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Middle Name</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.middleName.$error,
                                }"
                                v-model="model.middleName"
                              />
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted && !$v.model.middleName.maxLength
                                "
                                >Middle Name must be less than
                                {{ $v.model.middleName.$params.maxLength.max }}
                                characters</small
                              >
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Email</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.email.$error,
                                }"
                                v-model="model.email"
                              />
                              <div v-if="isSubmitted && $v.model.email.$error">
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.email.email"
                                  >Email is invalid</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.email.maxLength"
                                  >Email must be less than
                                  {{ $v.model.email.$params.maxLength.max }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <label>Phone</label>
                            <div class="row">
                              <div class="col-sm-5">
                                <div class="form-group">
                                  <v-select
                                    class="v-search-select"
                                    placeholder="Phone Code"
                                    label="label"
                                    v-model="model.phoneCode"
                                    :options="phoneCodes"
                                    :filter="searchPhoneCode"
                                    :clearable="true"
                                    :searchable="true"
                                    :filterable="true"
                                    :reduce="(option) => option.dial"
                                  >
                                    <template slot="option" slot-scope="option">
                                      <div class="phone-wrapper">
                                        <div
                                          class="phone-icon"
                                          :class="option.icon"
                                        ></div>
                                        <div class="phone-text">
                                          {{ option.country }}
                                        </div>
                                      </div>
                                    </template>
                                  </v-select>
                                </div>
                              </div>
                              <div class="col-sm-7">
                                <div class="form-group">
                                  <input
                                    type="text"
                                    class="form-control numbers-only"
                                    :class="{
                                      'field-error':
                                        isSubmitted &&
                                        $v.model.phoneNumber.$error,
                                    }"
                                    autocomplete="off"
                                    v-model="sanitizePhoneNumber"
                                  />
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      isSubmitted &&
                                      !$v.model.phoneNumber.maxLength
                                    "
                                    >Phone Number must be less than
                                    {{
                                      $v.model.phoneNumber.$params.maxLength.max
                                    }}
                                    characters</small
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Image URI</label>
                              <input
                                type="text"
                                class="form-control"
                                name="imageUri"
                                v-model="model.imageUri"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Landing Page</label>
                              <v-select
                                class="v-search-select"
                                placeholder=""
                                label="label"
                                v-model="model.landingPage"
                                :options="landingPages"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.url"
                              >
                              </v-select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="identity-user-role"
                        class="tab-pane fade"
                        :class="[activeTab === 'role' ? 'in active' : '']"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <label
                              class="cursor-pointer w-max-content"
                              v-for="item in model.modifiedRoles"
                              :key="item.id"
                            >
                              <input
                                type="checkbox"
                                class="control-checkbox"
                                v-model="item.isSelected"
                              />
                              <span
                                class="pl-5 font-weight-normal v-align-middle"
                              >
                                {{ item.name }}
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        id="identity-user-policy"
                        class="tab-pane fade"
                        :class="[activeTab === 'policy' ? 'in active' : '']"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <label
                              class="cursor-pointer w-max-content"
                              v-for="item in model.modifiedPolicies"
                              :key="item.id"
                            >
                              <input
                                type="checkbox"
                                class="control-checkbox"
                                v-model="item.isSelected"
                              />
                              <span
                                class="pl-5 font-weight-normal v-align-middle"
                              >
                                {{ item.name }}
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        id="identity-user-selector"
                        class="tab-pane fade"
                        :class="[activeTab === 'selector' ? 'in active' : '']"
                      >
                        <div class="form-group">
                          <label>Provider</label>
                          <multiselect
                            v-model="model.modifiedProviders"
                            group-values="items"
                            group-label="group"
                            placeholder="Select provider"
                            track-by="id"
                            label="name"
                            selectGroupLabel="Press enter to select all"
                            deselectGroupLabel="Press enter to deselect all"
                            :options="providers"
                            :multiple="true"
                            :limit="1"
                            :group-select="true"
                          >
                            <span slot="noResult" class="sts-danger"
                              >Sorry, no matching options.</span
                            >
                          </multiselect>
                        </div>
                        <div class="form-group">
                          <label>Company</label>
                          <multiselect
                            v-model="model.modifiedCompanies"
                            group-values="items"
                            group-label="group"
                            placeholder="Select company"
                            track-by="id"
                            label="name"
                            selectGroupLabel="Press enter to select all"
                            deselectGroupLabel="Press enter to deselect all"
                            :options="companies"
                            :multiple="true"
                            :limit="1"
                            :group-select="true"
                          >
                            <span slot="noResult" class="sts-danger"
                              >Sorry, no matching options.</span
                            >
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="userpasswordmodal">
      <div class="modal-dialog modal-xs">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Change Password</h4>
                <h6>Please fill all information below.</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div
                    class="summary-error"
                    v-if="$v.changePasswordModel.$error"
                  >
                    This form has errors
                  </div>
                  <form @submit.prevent="changePassword()">
                    <div class="form-group">
                      <label class="required">Password</label>
                      <input
                        type="password"
                        class="form-control"
                        :class="{
                          'field-error':
                            isSubmitted &&
                            $v.changePasswordModel.password.$error,
                        }"
                        v-model="changePasswordModel.password"
                      />
                      <div
                        v-if="
                          isSubmitted && $v.changePasswordModel.password.$error
                        "
                      >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.changePasswordModel.password.required"
                          >Password is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.changePasswordModel.password.maxLength"
                          >Password must be less than
                          {{
                            $v.changePasswordModel.password.$params.maxLength
                              .max
                          }}
                          characters</small
                        >
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        Change Password
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="useridpasswordmodal">
      <div class="modal-dialog modal-xs">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>User Synchronization</h4>
                <h6>Please fill all information below.</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.auth.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submitAuth()">
                    <div class="form-group">
                      <label class="required">Password</label>
                      <input
                        type="password"
                        class="form-control"
                        :class="{
                          'field-error': isSubmitted && $v.auth.password.$error,
                        }"
                        v-model="auth.password"
                      />
                      <div v-if="isSubmitted && $v.auth.password.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.auth.password.required"
                          >Password is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.auth.password.maxLength"
                          >Password must be less than
                          {{ $v.auth.password.$params.maxLength.max }}
                          characters</small
                        >
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        Sync
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, email, maxLength } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import identityRoleService from "@/services/master/identity/identityRoleService.js";
import identityUserService from "@/services/master/identity/identityUserService.js";
import identityPolicyService from "@/services/master/identity/identityPolicyService.js";
import providerService from "@/services/master/provider/providerService.js";
import companyService from "@/services/master/company/companyService.js";
import countryPhoneService from "@/services/master/countryPhoneService.js";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    validationRulePassword: function () {
      return !this.isUpdate ? { required, maxLength: maxLength(100) } : {};
    },
    sanitizePhoneNumber: {
      get() {
        return this.model.phoneNumber;
      },
      set(value) {
        this.model.phoneNumber = value.replace(/\D/g, "");
      },
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      isSubmitted: false,
      activeTab: "general",
      allPermissions: [],
      roles: [],
      policies: [],
      providers: [{ group: "Select all", items: [] }],
      companies: [{ group: "Select all", items: [] }],
      landingPages: [],
      phoneCodes: [],
      profile: null,
      isUpdate: false,
      itemToBeDeleted: null,
      items: [],
      model: {},
      auth: {},
      changePasswordModel: {
        isMobile: false,
        id: "",
        changePasswordId: "",
        password: "",
      },
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        username: { required, maxLength: maxLength(100) },
        password: this.validationRulePassword,
        firstName: { required, maxLength: maxLength(50) },
        middleName: { maxLength: maxLength(50) },
        lastName: { maxLength: maxLength(50) },
        email: { email, maxLength: maxLength(100) },
        phoneNumber: { maxLength: maxLength(20) },
      },
      changePasswordModel: {
        password: { required, maxLength: maxLength(100) },
      },
      auth: {
        password: { required, maxLength: maxLength(100) },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );

    this.profile = await this.$store.dispatch("user/getProfile");
    const permissions = this.profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
      await this.getPhoneCodes();
      await this.getRoles();
      await this.getPolicies();
      await this.getProviders();
      await this.getCompanies();
      await this.getPredefinedLandingPages();
    }
  },
  mounted() {
    $(this.$refs.usermodal).on("hidden.bs.modal", this.closeModal);
  },
  updated() {
    this.$helper.collapseMenu("security");
    this.$helper.setNavigationClass("identity-user-link");
    this.$helper.numbersOnly();
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    resetModel() {
      this.model = {};
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
      this.$v.changePasswordModel.$reset();
      this.$v.auth.$reset();
    },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.usermodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.usermodal).modal("hide");
      $(this.$refs.userpasswordmodal).modal("hide");
    },
    createItem() {
      this.resetModel();
      this.isUpdate = false;
      this.activeTab = "general";

      this.openModal({
        modifiedRoles: this.roles.map(function (item) {
          return { isSelected: false, id: item.id, name: item.name };
        }),
        modifiedPolicies: this.policies.map(function (item) {
          return { isSelected: false, id: item.id, name: item.name };
        }),
        modifiedProviders: [],
        modifiedCompanies: [],
        phoneNumber: "",
      });
    },
    async updateItem(id) {
      try {
        this.isLoading = true;
        const response = await identityUserService.getById(id);
        const item = response.data;
        this.isUpdate = true;
        this.activeTab = "general";
        item.modifiedRoles = [];
        for (let i = 0; i < this.roles.length; i++) {
          const selectedRole = item.roles.find((x) => x === this.roles[i].id);
          item.modifiedRoles.push({
            isSelected: selectedRole !== undefined && selectedRole !== null,
            id: this.roles[i].id,
            name: this.roles[i].name,
          });
        }

        item.modifiedPolicies = [];
        for (let i = 0; i < this.policies.length; i++) {
          const selectedPolicy = item.policies.find(
            (x) => x === this.policies[i].id
          );
          item.modifiedPolicies.push({
            isSelected: selectedPolicy !== undefined && selectedPolicy !== null,
            id: this.policies[i].id,
            name: this.policies[i].name,
          });
        }

        if (item.providers.length === this.providers[0].items.length) {
          item.modifiedProviders = this.providers.find(
            (option) => option.group === "Select all"
          ).items;
        } else {
          item.modifiedProviders = [];
          for (let i = 0; i < this.providers[0].items.length; i++) {
            const selectedProvider = item.providers.find(
              (x) => x === this.providers[0].items[i].id
            );
            if (selectedProvider) {
              item.modifiedProviders.push(this.providers[0].items[i]);
            }
          }
        }

        if (item.companies.length === this.companies[0].items.length) {
          item.modifiedCompanies = this.companies.find(
            (option) => option.group === "Select all"
          ).items;
        } else {
          item.modifiedCompanies = [];
          for (let i = 0; i < this.companies[0].items.length; i++) {
            const selectedCompany = item.companies.find(
              (x) => x === this.companies[0].items[i].id
            );
            if (selectedCompany) {
              item.modifiedCompanies.push(this.companies[0].items[i]);
            }
          }
        }

        this.openModal(item);
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async resetPassword(item) {
      this.changePasswordModel = {
        id: "",
        changePasswordId: "",
        password: "",
      };
      this.resetValidations();
      try {
        const response = await identityUserService.forgotPassword({
          id: item.id,
          isSendEmail: false,
        });
        if (response.data) {
          this.changePasswordModel.id = item.id;
          this.changePasswordModel.changePasswordId = response.data;
          $(this.$refs.userpasswordmodal).modal();
        } else {
          this.$notification.error("User not found.");
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
        await this.getAll();
      }
    },
    openAuthModal(item) {
      this.resetValidations();
      this.auth = { id: item.id, password: null };
      if (item.username != item.email) {
        this.auth.isMobile = true;
      } else {
        this.auth.isMobile = false;
      }
      $(this.$refs.useridpasswordmodal).modal();
    },
    async submitAuth() {
      this.isSubmitted = true;
      this.$v.auth.$touch();
      if (this.$v.auth.$error) {
        return;
      }
      try {
        this.isLoading = true;
        await identityUserService.syncAuth(this.auth);
        this.$notification.success("Successfully synced.", {
          title: "Success",
        });
        this.closeAuthModal();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    closeAuthModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.useridpasswordmodal).modal("hide");
    },
    async getAll() {
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        const response = await identityUserService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getRoles() {
      this.roles = await identityRoleService.getAllActive();
    },
    async getPolicies() {
      this.policies = await identityPolicyService.getAllActive();
    },
    async getProviders() {
      const _providers = await providerService.getAllActive();
      this.providers = [{ group: "Select all", items: _providers }];
    },
    async getCompanies() {
      const _companies = await companyService.getAllActive();
      this.companies = [{ group: "Select all", items: _companies }];
    },
    async getPhoneCodes() {
      this.phoneCodes = await countryPhoneService.getAll();

      for (let i = 0; i < this.phoneCodes.length; i++) {
        const item = this.phoneCodes[i];
        item.label = `+${item.dial}`;
        item.icon = `iti-flag ${item.iata.toLowerCase()}`;
      }
    },
    searchPhoneCode(options, search) {
      const pattern = new RegExp(search.toLowerCase(), "i");
      return this.phoneCodes.filter((item) => {
        return (
          pattern.test(item.area) ||
          pattern.test(item.country) ||
          pattern.test(item.dial) ||
          pattern.test(item.iata)
        );
      });
    },
    getPredefinedLandingPages() {
      let index = 1;
      this.landingPages = this.$router.options.routes
        .filter((el) => el.children)
        .map((val) => val.children)
        .flat()
        .filter((f) => f.meta && f.meta.title)
        .map((x) => {
          return {
            url: x.path,
            title: x.meta.title,
            label: `${index++}. ${x.meta.title} (${x.path})`,
          };
        });
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();

      if (this.$v.model.$error) {
        return;
      }

      try {
        this.isLoading = true;
        const payload = this.constructPayload();

        if (this.isUpdate) {
          await identityUserService.update(payload);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          await identityUserService.create(payload);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }

        await this.$store.dispatch("user/removeProfile");
        await this.getAll();
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        if (this.isUpdate) window.location.reload();
      }
    },
    sanitize(value) {
      if (typeof value !== "string") return value;

      return value
        .replace(/[\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, "")
        .trim();
    },
    constructPayload() {
      const payload = {
        username:
          this.model.username && this.model.username.trim().length > 0
            ? this.sanitize(this.model.username)
            : null,
        email:
          this.model.email && this.model.email.trim().length > 0
            ? this.model.email.trim()
            : null,
        firstName:
          this.model.firstName && this.model.firstName.trim().length > 0
            ? this.model.firstName.trim()
            : null,
        lastName:
          this.model.lastName && this.model.lastName.trim().length > 0
            ? this.model.lastName.trim()
            : null,
        middleName:
          this.model.middleName && this.model.middleName.trim().length > 0
            ? this.model.middleName.trim()
            : null,
        phoneNumber:
          this.model.phoneNumber && this.model.phoneNumber.trim().length > 0
            ? this.sanitize(this.model.phoneNumber)
            : null,
        phoneCode:
          this.model.phoneCode && this.model.phoneCode.trim().length > 0
            ? this.model.phoneCode.trim()
            : null,
        imageUri:
          this.model.imageUri && this.model.imageUri.trim().length > 0
            ? this.model.imageUri.trim()
            : null,
        landingPage:
          this.model.landingPage && this.model.landingPage.trim().length > 0
            ? this.model.landingPage.trim()
            : null,
        roles: this.model.modifiedRoles
          .filter((x) => x.isSelected)
          .map((x) => x.id),
        policies: this.model.modifiedPolicies
          .filter((x) => x.isSelected)
          .map((x) => x.id),
        providers: [],
        companies: [],
      };

      if (
        this.model.modifiedProviders &&
        this.model.modifiedProviders.length > 0
      ) {
        payload.providers = this.model.modifiedProviders.map((x) => x.id);
      }

      if (
        this.model.modifiedCompanies &&
        this.model.modifiedCompanies.length > 0
      ) {
        payload.companies = this.model.modifiedCompanies.map((x) => x.id);
      }

      if (this.isUpdate) {
        payload.id = this.model.id;
      } else {
        payload.password =
          this.model.password && this.model.password.trim().length > 0
            ? this.model.password.trim()
            : null;
      }

      return payload;
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        if (item.isActive) {
          await identityUserService.reactivate({ id: item.id });
          this.$notification.success("Successfully reactivated."),
            { title: "Success" };
        } else {
          await identityUserService.deactivate({ id: item.id });
          this.$notification.success("Successfully deactivated.", {
            title: "Success",
          });
        }
        await this.$store.dispatch("user/removeProfile");
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await identityUserService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.$store.dispatch("user/removeProfile");
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changePassword() {
      this.isSubmitted = true;
      this.$v.changePasswordModel.$touch();
      if (this.$v.changePasswordModel.$error) {
        return;
      }
      try {
        this.isLoading = true;
        debugger;
        await identityUserService.changePassword(this.changePasswordModel);
        this.$notification.success("Password changed successfully.", {
          title: "Success",
        });
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    isHimSelf(username) {
      return this.profile.username === username;
    },
    userItemContainSelector(user) {
      return (
        (user.selectors.Companies && user.selectors.Companies.length > 0) ||
        (user.selectors.Providers && user.selectors.Providers.length > 0)
      );
    },
    printSelectorIndicator(selectors) {
      let labels = [];

      if (selectors) {
        if (selectors.Providers && selectors.Providers.length > 0) {
          labels.push(`${selectors.Providers.length} provider(s)`);
        }
        if (selectors.Companies && selectors.Companies.length > 0) {
          labels.push(`${selectors.Companies.length} company(s)`);
        }
      }

      return labels.length > 0 ? labels.join(", ") : "N/A";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/security/identity/IdentityUser.vue